var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoDrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 121.5,
    height: 129.182,
    viewBox: "0 0 121.5 129.182",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_210",
    "data-name": "Group 210",
    transform: "translate(-163.5 -310)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "info-square-svgrepo-com",
    transform: "translate(164 336.504)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_269",
    "data-name": "Path 269",
    d: "M12,40.453V11",
    transform: "translate(39.089 35.18)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_52",
    "data-name": "Ellipse 52",
    cx: 4.541,
    cy: 4.541,
    r: 4.541,
    transform: "translate(46.274 26.975)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_270",
    "data-name": "Path 270",
    d: "M100.178,51.089c0,23.141,0,34.711-7.189,41.9s-18.759,7.189-41.9,7.189-34.711,0-41.9-7.189S2,74.229,2,51.089s0-34.711,7.189-41.9S27.948,2,51.089,2,85.8,2,92.989,9.189c4.78,4.78,6.382,11.5,6.919,22.264",
    transform: "translate(0 0)",
    fill: "rgba(255,255,255,0)",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_209",
    "data-name": "Group 209",
    transform: "translate(0 1)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_67",
    "data-name": "Ellipse 67",
    cx: 20.5,
    cy: 20.5,
    r: 20.5,
    transform: "translate(244 309)",
    fill: "#7320ce"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-plus",
    "data-name": "Icon feather-plus",
    transform: "translate(246.5 311.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_301",
    "data-name": "Path 301",
    d: "M18,7.5v21",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_302",
    "data-name": "Path 302",
    d: "M7.5,18h21",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoDrop);
export default __webpack_public_path__ + "static/media/info_drop.36150e25e2c3f1af29252ac8aec2f5f7.svg";
export { ForwardRef as ReactComponent };